:host {
  @apply flex;
}
